import { localisedSEO } from '../data/seoLocales';

/** Use the existing localized route copy for shared navigation and footer links. */
export function localizedRouteLabel(lang: string, route: string, fallback: string): string {
  if (lang === 'en') return fallback;
  const path = route.split(/[?#]/, 1)[0].replace(/\/$/, '') || '/';
  const copy = localisedSEO(lang, path);
  const label = copy?.h1 || copy?.title;
  if (!label) return fallback;
  return label.split(/\s+[\u2014\u2013-]\s+|:\s+/u, 1)[0].trim() || fallback;
}

export function topNavLabel(id: string, fallback: string, t: (key: string) => string): string {
  if (id === 'about') return t('nav.about');
  const translated = t(`chrome.${id}`);
  return translated === `chrome.${id}` ? fallback : translated;
}

export function navGroupLabel(group: string, t: (key: string) => string): string {
  if (group === 'Browse') return t('chrome.browse');
  if (group === 'Popular') return t('chrome.popular');
  if (group === 'Gaming & Pop Culture') return t('chrome.gaming');
  return group;
}
